import React, { useState } from 'react';
import tokml from 'tokml';
import GeoJSON from 'geojson';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Select,
  MenuItem,
} from '@mui/material';

function BulkDownloadPickupZones({
  isOpen, onCancel, zones, marketName, tableData, tableColumns,
}) {
  const [fileType, setFileType] = useState('');
  const downloadOptions = ['CSV', 'KML'];

  const closeModal = () => onCancel();

  const downloadFile = (extensionType, fileContent) => {
    const URL = window.URL || window.webkitURL;
    const fileName = `${marketName}PickupZones`;
    let type;

    if (extensionType === 'csv') type = 'text/csv';
    else type = 'text/xml';

    try {
      const blob = new Blob([fileContent], { type });
      const link = document.createElement('a');
      const downloadURI = URL.createObjectURL(blob);
      link.setAttribute('href', downloadURI);
      link.setAttribute('download', `${fileName}.${extensionType}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(error);
    }
  };

  const downloadCsv = (data, extension) => {
    let csvString = '';
    data.forEach((row) => {
      csvString += row.join(',');
      csvString += '\n';
    });
    downloadFile(extension, csvString);
  };

  const handleFileDownload = (option) => {
    if (!zones) return;

    const extension = option.toLowerCase();
    if (extension === 'csv') {
      if (!tableColumns || !tableData) return;
      const columns = tableColumns.map((col) => col.name);
      const csvData = [[...columns], ...tableData];
      downloadCsv(csvData, extension);
    } else {
      const data = zones.map((zone) => {
        const zonePolygon = zone.boundary.coordinates;
        const polygonObj = {
          polygon: zonePolygon.length > 0
            ? [zonePolygon[0][0].map((row) => [row[0], row[1]])]
            : [[]],
          name: zone.name,
        };
        return polygonObj;
      });
      const geoJsonObj = GeoJSON.parse(data, {
        Polygon: 'polygon',
        include: ['name'],
      });
      const kmlData = tokml(geoJsonObj, {
        name: 'Pick Up Zones',
        description: 'description',
        documentName: 'Pick Up Zones',
        documentDescription: `Pickup Zones for ${marketName}`,
        simplestyle: false,
      });
      downloadFile(extension, kmlData);
    }
  };

  if (!fileType) {
    return (
      <Dialog
        open={isOpen}
        maxWidth="md"
        aria-labelledby="bulk-upload-form-dialog-title"
        onClose={closeModal}
      >
        <DialogTitle id="form-dialog-title" spacing={1}>
          <Typography>Download CSV or KML File for Pick Up Zones</Typography>
        </DialogTitle>
        <DialogContent>
          <Select
            style={{ width: '80%' }}
            // fullWidth
            onChange={(e) => setFileType(e.target.value)}
            value={fileType}
            inputProps={{
              name: 'selectedFileType',
              id: 'file-type-picker',
            }}
            options={downloadOptions}
          >
            {downloadOptions.map(
              (option, i) => (<MenuItem key={`option-${i + 1}-${option}`} value={option}>{option}</MenuItem>),
            )}
          </Select>
        </DialogContent>
      </Dialog>
    );
  } else {
    closeModal();
    handleFileDownload(fileType);
    return null;
  }
}

export default BulkDownloadPickupZones;
